export function sanitizeFilenamePart(value: string): string {
  if (!value) {
    return '';
  }

  return value
    .replace(/[\\/:*?"<>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function buildLabeledFilename(label: string, title: string): string {
  const cleanLabel = sanitizeFilenamePart(label);
  const cleanTitle = sanitizeFilenamePart(title);

  if (!cleanLabel) {
    return cleanTitle;
  }
  if (!cleanTitle) {
    return cleanLabel;
  }

  return `${cleanLabel} - ${cleanTitle}`;
}
